import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

class TicketComment extends React.Component {

    constructor(props) {
        super(props);

        this.handleCommentChange = this
            .handleCommentChange
            .bind(this);
    }

    handleCommentChange(e) {
        const { workOrderActions, orderCloseDetails, orderId, workType } = this.props;

        const exsistingTicket = orderCloseDetails
            .getIn(['closeOrderRequest', 'ticketRequests'])
            .find((item) => {

                return item.get('workType') === workType;

            });

        if (exsistingTicket) {
            workOrderActions.ticketRequestAdd({
                workType: workType,
                customerImpacting: exsistingTicket.get('customerImpacting'),
                comment: e.target.value,
                pmTicketSignalLevel: exsistingTicket.get('pmTicketSignalLevel')
            }, orderId);
        }

    }

    render() {
        const { orderCloseDetails, workType } = this.props;

        let exsistingTicket = null,
            comment = '',
            stepTwoStyle = {};

        if (orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests'])) {

            exsistingTicket = orderCloseDetails
                .getIn(['closeOrderRequest', 'ticketRequests'])
                .find((item) => {
                    return item.get('workType') === workType;

                });

            if (exsistingTicket) {
                comment = exsistingTicket.get('comment');
            }

        }

        if (!exsistingTicket) {
            stepTwoStyle = {
                display: 'none'
            };
        }

        return (

            <div style={stepTwoStyle}>
                <label>
                    Comments:</label>
                <TextField
                    fullWidth
                    value={comment ? comment : ''}
                    floatingLabelText="Enter Comments"
                    multiLine={true}
                    onChange={this.handleCommentChange}
                    rows={2}
                    maxLength="70" />
            </div>
        );

    }
}

TicketComment.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    workType: PropTypes.string
};

export default TicketComment;



// WEBPACK FOOTER //
// ./src/components/ticket/TicketComment.js